import styled from 'styled-components';

const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 49; // in sm

const caculateViewerHeight = ({ height, isAtlas, isFixedHeight, isFullScreen }) => {
  if (isAtlas) return '100%';

  if (isFullScreen) return '100vh';

  if (isFixedHeight) {
    return height;
  }

  const finalHeightToRemove = isFixedHeight === true ? 0 : NAV_BAR_HEIGHT + HEADER_HEIGHT;

  return `calc(${height} - ${finalHeightToRemove}px)`;
};

const Viewer = styled.div`
  position: relative;
  height: ${props => caculateViewerHeight(props)};
  width: 100%;
  z-index: 10;
`;

export default {
  Viewer
};
